'use client'

import { useEffect } from 'react'

export function FontLoaderOptimized() {
  useEffect(() => {
    // More efficient font loading using Font Loading API
    const loadSecondaryFonts = async () => {
      if ('fonts' in document) {
        try {
          // Define secondary fonts
          const fontMedium = new FontFace(
            'THICCCBOI',
            'url(/fonts/THICCCBOI-Medium.woff2)',
            {
              weight: '500',
              style: 'normal',
              display: 'swap'
            }
          )
          
          const fontSemiBold = new FontFace(
            'THICCCBOI',
            'url(/fonts/THICCCBOI-SemiBold.woff2)',
            {
              weight: '600',
              style: 'normal',
              display: 'swap'
            }
          )

          // Load fonts in parallel
          const [loadedMedium, loadedSemiBold] = await Promise.all([
            fontMedium.load(),
            fontSemiBold.load()
          ])

          // Add to document
          document.fonts.add(loadedMedium)
          document.fonts.add(loadedSemiBold)
          
          // Add class to indicate fonts are loaded
          document.documentElement.classList.add('fonts-loaded')
          
          // Update styles for elements that use these weights
          const style = document.createElement('style')
          style.textContent = `
            .fonts-loaded h2,
            .fonts-loaded h3 {
              font-weight: 600;
            }
            .fonts-loaded h4,
            .fonts-loaded h5,
            .fonts-loaded h6 {
              font-weight: 500;
            }
          `
          document.head.appendChild(style)
        } catch (error) {
          console.error('Failed to load secondary fonts:', error)
          // Fallback to link method
          fallbackFontLoad()
        }
      } else {
        // Fallback for browsers without Font Loading API
        fallbackFontLoad()
      }
    }

    const fallbackFontLoad = () => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = '/css/fonts-secondary.css'
      link.onload = () => {
        document.documentElement.classList.add('fonts-loaded')
      }
      document.head.appendChild(link)
    }

    // Load after idle or timeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadSecondaryFonts, { timeout: 2000 })
    } else {
      setTimeout(loadSecondaryFonts, 50)
    }
  }, [])

  return null
}